import * as R from 'ramda';


/**
 * getResErrorMsg :: AxiosResponse -> String,
 * AxiosResponse = Object
 */
export const getResErrorMsg = error => R.pathOr(
  R.pathOr('Unknown server error', ['message'], error),
  ['response', 'data', 'error', 'message'],
)(error);



// WEBPACK FOOTER //
// ./src/utils/axios.js